import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class InvoiceLinesPricingAdjustmentBus extends BaseBus
{
    constructor(busObj: BaseBus = null) {
        super(busObj);

    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {

    }
    setParentId(id: any) {
    }

    setBeforeSave() {

    }
 invoiceLineId: any;
 quantity: number;
 price: number;
}
